import {IUserReservationService} from "../../domain/leasing/IUserReservationService";
import {UserReservation} from "../../../../../server/src/base/entities/leasing/calendar/UserReservation";
import {UserReservations} from "../../../../../server/src/base/entities/leasing/calendar/UserReservations";
import {ApiAccessService} from "../api/ApiAccessService";

export class UserReservationService implements IUserReservationService{

    private apiAccessService:ApiAccessService;

    constructor(apiAccessService:ApiAccessService){
        this.apiAccessService = apiAccessService;
    }

    public Get(id: string): Promise<UserReservation> {
        return this.apiAccessService.Get("leasing/reservation/" + id, UserReservation);
    }

    public Create(userReservation: UserReservation): Promise<void> {
        return this.apiAccessService.Post("leasing/reservation", userReservation);
    }

    public Update(userReservation: UserReservation): Promise<void> {
        return this.apiAccessService.Patch("leasing/reservation/update", userReservation);
    }

    public Cancel(userReservation: UserReservation): Promise<void> {
        return this.apiAccessService.Delete("leasing/reservation/cancel/" + userReservation.id);
    }

    public GetAll(): Promise<UserReservations> {
        return this.apiAccessService.Get("leasing/reservations", UserReservations);
    }

    public Validate(userReservation: UserReservation): Promise<void> {
        return this.apiAccessService.Patch("leasing/reservation/validate/" + userReservation.id);
    }
}


// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/app/infrastructure/leasing/UserReservationService.ts